import * as _ from "lodash";

export class Sentiment {
    static Positive      = new Sentiment("Positive", "rgb(106, 184, 82)");
    static Neutral       = new Sentiment("Neutral",  "rgb(239, 204, 50)");
    static Negative      = new Sentiment("Negative", "rgb(203, 83, 84)");
    static AllSentiments = [Sentiment.Positive, Sentiment.Neutral, Sentiment.Negative];

    static sentimentWithName(name: string): Sentiment {
        return _.find(Sentiment.AllSentiments, it => it.name == name) || new Sentiment(name, "magenta");
    }

    private constructor(public name: string, public color: string) {
    }

    get iconPath(): string {
        return `assets/app/images/icon-${this.name}.png`;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/model/sentiment.ts